module.exports = __webpack_public_path__ + "img/dark.9b4f7607.png";